import PropTypes from "prop-types";
import React, {PureComponent} from "react";
import {Link} from "react-router-dom";
import {connect} from "react-redux";

import {ActionCreator} from "../reducers/application/application";
import {AppRoute} from "../const";
import {BackButton} from "./back-button";
import {CatchAreasCount} from "./catch-areas-count";
import {PeriodDataPropType, PoolPropType, ResearchPropType} from "../prop-types";
import {Research} from "./research";
import {Toggle} from "./toggle";
import {getActiveAreaId, getActiveDataMode, getActivePeriodId} from "../reducers/application/selectors";
import {getActivePeriod, getActivePool, getCatchAreasCount} from "../reducers/data/selectors";
import {getPoolRegions} from "../utils/utils";
import {getTotalResearches} from "../reducers/data/selectors";


class SidebarComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      areaId: this.props.activeAreaId,
    };

    this._handleToggleClick = this._handleToggleClick.bind(this);
  }

  componentDidUpdate() {
    const oldAreaId = this.state.areaId;
    const newAreaId = this.props.activeAreaId;

    if (oldAreaId !== newAreaId) {
      this.setState({
        areaId: newAreaId,
      });
      document.activeElement.blur();
    }
  }

  _handleToggleClick(event) {
    this.props.onToggleClick(event.target.value);
  }

  render() {
    const activePeriod = this.props.activePeriod;
    const periodPageTitle = activePeriod.pageTitle;
    const catchAreasCount = this.props.catchAreasCount;
    const totalResearches = this.props.totalResearches;
    const activeDataMode = this.props.activeDataMode;
    const activePeriodId = this.props.activePeriodId;
    const pool = this.props.pool;
    const activeAreaId = this.props.activeAreaId;
    const isMainPage = window.location.pathname === AppRoute.MAIN;
    const regions = pool ? getPoolRegions(pool) : null;

    return (
      <section className="sidebar">
        <h2 className="visually-hidden">Блок управления картой</h2>

        <div className="sidebar__info">
          {isMainPage &&
            <React.Fragment>
              <h3 className="sidebar__title">
                Основные данные мониторинга ветеринарной безопасности
                <span className="sidebar__period">{periodPageTitle}</span>
              </h3>

              <div className="sidebar__info-container">
                <CatchAreasCount
                  className="sidebar__catch-areas-count"
                  title="Количество районов вылова водных биологических ресурсов Российской Федерации"
                  count={catchAreasCount}
                />

                <Research
                  className="sidebar__research"
                  totalResearches={totalResearches}
                />
              </div>
            </React.Fragment>
          }

          {!isMainPage && pool &&
            <React.Fragment>
              <div className="sidebar__title-wrapper">
                <BackButton activePeriodId={activePeriodId} />
                <h3 className="sidebar__title">Районы вылова</h3>
              </div>

              <div className="sidebar__info-container">
                <ul className="sidebar__catch-areas  catch-areas">
                  {
                    regions.map((region, index) => {
                      return (
                        <li key={region + index} className="catch-areas__item">
                          {region !== `MAIN` && <h6 className="catch-areas__region">{region}</h6>}
                          <ul className="catch-areas__areas">
                            {
                              pool.catchAreas
                                .filter((area) => area.region === region)
                                .map((area, areaIndex) => {
                                  const isActive = area.id === activeAreaId;

                                  return (
                                    <li key={area + areaIndex} className="catch-areas__area-item">
                                      <Link
                                        className={`catch-areas__area-title  ${isActive && `catch-areas__area-title--active`}`}
                                        to={{
                                          pathname: AppRoute.AREA.replace(`:id`, pool.id).replace(`:areaId`, area.id),
                                          search: activePeriodId ? `?period=${activePeriodId}` : ``
                                        }}
                                      >
                                        {area.title}
                                      </Link>
                                    </li>
                                  );
                                })
                            }
                          </ul>
                        </li>
                      );
                    })
                  }
                </ul>
              </div>
            </React.Fragment>
          }
        </div>

        <Toggle
          activeDataMode={activeDataMode}
          onChange={this._handleToggleClick}
        />
      </section>
    );
  }
}


SidebarComponent.propTypes = {
  catchAreasCount: PropTypes.number.isRequired,
  totalResearches: PropTypes.arrayOf(ResearchPropType).isRequired,
  activeDataMode: PropTypes.string.isRequired,
  activePeriodId: PropTypes.string.isRequired,
  activePeriod: PeriodDataPropType.isRequired,
  pool: PoolPropType,
  activeAreaId: PropTypes.string,
  onToggleClick: PropTypes.func.isRequired,
};


const mapStateToProps = (state) => ({
  catchAreasCount: getCatchAreasCount(state),
  totalResearches: getTotalResearches(state),
  activeDataMode: getActiveDataMode(state),
  activePeriodId: getActivePeriodId(state),
  activePeriod: getActivePeriod(state),
  pool: getActivePool(state),
  activeAreaId: getActiveAreaId(state),
});

const mapDispatchToProps = (dispatch) => ({
  onToggleClick(dataMode) {
    dispatch(ActionCreator.changeActiveDataMode(dataMode));
  },
});

const Sidebar = connect(mapStateToProps, mapDispatchToProps)(SidebarComponent);


export {
  SidebarComponent,
  Sidebar,
};
